import { render, staticRenderFns } from "./ProfileIcon.vue?vue&type=template&id=605e4c2a&scoped=true&lang=pug"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"
import style0 from "./ProfileIcon.vue?vue&type=style&index=0&id=605e4c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e4c2a",
  null
  
)

export default component.exports